export default __webpack_public_path__ + "static/media/StaticPage1.f697e177.txt";